import React from "react";
import { connect } from "react-redux";
import { Table, TableBody } from "@material-ui/core";
import { compose } from "recompose";
import RelatedProtocolTableHeader from "./RelatedProtocolTableHeader";
import RelatedProtocolTableEmptyRow from "./RelatedProtocolTableEmptyRow";
import RelatedProtocolTableRow from "./RelatedProtocolTableRow";
import { sgRelatedProtocolsSelector } from "../../../redux/selectors";

const RelatedProtocolsTable = ({ protocols }) => {
  return (
    <Table>
      <RelatedProtocolTableHeader />
      <TableBody>
        {!!protocols?.length &&
          protocols.map((protocol) => {
            return (
              <RelatedProtocolTableRow
                key={JSON.stringify(protocol)}
                protocol={protocol}
              />
            );
          })}
        {!protocols?.length && <RelatedProtocolTableEmptyRow />}
      </TableBody>
    </Table>
  );
};

const mapStateToProps = (state) => ({
  protocols: sgRelatedProtocolsSelector(state),
});

const mapDispatchToProps = () => ({});

const enhance = compose(connect(mapStateToProps, mapDispatchToProps));

export default enhance(RelatedProtocolsTable);
